import React from "react";
import PropTypes from "prop-types";
import Feature from "./feature";

const Invisible = ({ name, off, on }) => {
  const today = new Date();
  const mark =
    today.getFullYear() * 10000 + today.getMonth() * 100 + today.getDate();
  return <Feature name={name} off={off} on={on} expire={mark} />;
};

Invisible.propTypes = {
  name: PropTypes.string.isRequired,
  off: PropTypes.func.isRequired,
  on: PropTypes.func.isRequired,
};

export default Invisible;
